import { config } from '@fortawesome/fontawesome-svg-core'
import { ThemeProvider } from '@karnov/kui-react'
import { ErrorBoundary } from '@rollbar/react'
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { AppRoutes } from 'AppRoutes'
import { PageLoader } from 'components/PageLoader'
import { ScreenSizeUpdater } from 'components/ScreenSizeUpdater'
import { NotificationsWrapper } from 'contexts/notificationsWrapper'
import { QueryProvider } from 'contexts/reactQuery'
import { RollbarProvider } from 'contexts/rollbarProvider'
import { TrackingEventsProvider } from 'contexts/trackingEventsProvider'
import { ErrorPage } from 'pages/ErrorPage'

import 'services/i18n'
import 'services/nonce'
import './index.css'

config.autoAddCss = false

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter basename="/ai">
      <Suspense fallback={<PageLoader />}>
        <QueryProvider>
          <RollbarProvider>
            <ScreenSizeUpdater />
            <ErrorBoundary
              fallbackUI={err => <ErrorPage message={err.error?.message} />}
            >
              <ThemeProvider>
                <NotificationsWrapper>
                  <TrackingEventsProvider>
                    <AppRoutes />
                  </TrackingEventsProvider>
                </NotificationsWrapper>
              </ThemeProvider>
            </ErrorBoundary>
          </RollbarProvider>
        </QueryProvider>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
)
